import { NgxButtonComponent } from '@digipay/ngx-button';
import { Component, inject } from '@angular/core';
import { IPaymentMethod } from './models/payment-method.interface';
import { IPO_ROUTE, PAYMENT_METHOD_CONDITIONS_ROUTE } from '../../data-access/constants/app-routes';
import { ActivatedRoute } from '@angular/router';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { EIpoPaymentMethodAgreement } from './models/ipo-payment-method-agreement';
import { BaseComponent } from '../../components/core/components/base/base.component';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { NgClass } from '@angular/common';

@Component({
  selector: 'wealth-applet-choice-payment-way',
  standalone: true,
  imports: [NgxAppBarComponent, NgxButtonComponent, NgClass],
  templateUrl: './choice-payment-way.component.html',
  styleUrl: './choice-payment-way.component.scss',
})
export class ChoicePaymentWayComponent extends BaseComponent {
  paymentMethods: IPaymentMethod[] = [
    {
      id: EIpoPaymentMethodAgreement.ByCredit,
      title: 'سرمایه‌گذاری با اعتبار کارگزاری',
      description:
        'در این روش کارگزاری به شما اعتبار می‌دهد. شما ۵ روز فرصت دارید با شارژ کیف پول ETF خود در سبد دارایی این بدهی را بپردازید، در غیر این صورت کارگزاری سهام را فروخته و بعد از کسر بدهی، باقی‌مانده مبلغ را به کیف پول ETF شما واریز می‌کند.',
      selected: true,
      agreementChecked: false,
    },
    {
      id: EIpoPaymentMethodAgreement.ByCharge,
      title: 'سرمایه‌گذاری از طریق درگاه بانکی',
      description:
        'شما مبلغ سرمایه‌گذاری را در درگاه بانکی پرداخت خواهید کرد. اگر مبلغ نهایی شده خرید کمتر از مبلغ پرداختی شما باشد، باقی‌مانده آن به کیف پول ETF شما واریز خواهد شد.',
      selected: false,
      agreementChecked: false,
    },
  ];

  symbol: string;

  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);
  state: any;
  selectedMethod: IPaymentMethod = this.paymentMethods[0];
  agreements: string[];
  agreementChecked: boolean;

  constructor(private route: ActivatedRoute) {
    super();
    this.state = this.routeState.getAll();
    this.symbol = this.route.snapshot.params['id'];
  }

  onBackHandler() {
    this.navigationService.navigate([IPO_ROUTE, this.symbol]);
  }

  updateSelectedMethod(method: IPaymentMethod) {
    this.paymentMethods.forEach((item) => {
      if (item.title === method.title) {
        item.selected = true;
        this.selectedMethod = item;
      } else {
        item.selected = false;
      }
    });
  }

  continue() {
    this.navigationService.navigate([PAYMENT_METHOD_CONDITIONS_ROUTE, this.symbol], {
      state: {
        ...this.state,
        agreementType: this.selectedMethod.id,
      },
    });
  }
}
